import { useOpenRepoOnGitHubCommand } from "commands/definitions/integrations/useOpenRepoOnGitHubCommand";
import { useRegisterCommands } from "components/Layout/Panels/VSCode/useRegisterCommands";
import { useEditor } from "features/editor/Feature";

export const useRegisterIntegrationCommands = (): void => {
  const editor = useEditor();

  if (editor.type === "sandbox") {
    return;
  }

  // eslint-disable-next-line
  const openRepoOnGithubCommand = useOpenRepoOnGitHubCommand({
    owner: editor.owner,
    repo: editor.repo,
  });

  // eslint-disable-next-line
  useRegisterCommands([openRepoOnGithubCommand], [editor.owner, editor.repo]);
};
